import { render } from "./CompanyHierarchyCard.vue?vue&type=template&id=a2d6ce00"
import script from "./CompanyHierarchyCard.vue?vue&type=script&lang=js"
export * from "./CompanyHierarchyCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/steve/Desktop/valet/rspremote/web/app/themes/rspremote/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__